// extracted by mini-css-extract-plugin
export default {"config":"SeriesFilterDialog_config__9ttMS","remove":"SeriesFilterDialog_remove__9-Lpu"};